import { memo, useEffect, useRef } from 'react'
import { useIntl } from 'react-intl'
import { TextInput, TouchableOpacity, View } from 'react-native'
import styled, { useTheme } from 'styled-components'
import { Icon } from '../../../elements/images/Icon'
import { media } from '../../../style/media'
import { outlineNone } from '../../../style/webStyles'
import messages from '../messages'

const FullWidth = styled(View)`
  width: 100%;
`

const Container = styled(FullWidth)`
  flex-direction: row;
  align-items: center;
  margin-top: ${(props) => props.theme.spacing.small}px;
  margin-bottom: ${(props) => props.theme.spacing.smedium}px;
`

const InputBox = styled(View)`
  flex-grow: 1;
  border-width: 0;
  border-bottom-width: 2px;
  border-color: ${(props) => props.theme.colors.grayLighter};
  margin: 0 ${(props) => props.theme.spacing.small}px;
`

const InputText = styled(TextInput)`
  color: ${(props) => props.theme.colors.white};
  font-size: ${(props) => props.theme.fontSizes.small}px;
  font-weight: ${(props) => props.theme.fontWeights.normal};
  font-family: ${(props) => props.theme.fontFamilies.base};
  height: 45px;
  ${outlineNone};
  ${media.sm`
    font-size: ${(props) => props.theme.fontSizes.large}px;
  `};
`

const ClearButton = styled(TouchableOpacity)`
  padding: 0 ${(props) => props.theme.spacing.small}px;
  ${outlineNone};
`

export const SearchInput = memo(
  ({ value, onChangeText, placeholder, focusOnMount = true, clearSearch = true, children }) => {
    const intl = useIntl()
    const input = useRef()
    const theme = useTheme()

    useEffect(() => {
      if (focusOnMount) {
        input.current.focus()
      }
    }, [focusOnMount])

    return (
      <FullWidth>
        <Container>
          <InputBox>
            <InputText
              ref={input}
              value={value}
              onChangeText={onChangeText}
              placeholderTextColor={theme.colors.placeholder}
              placeholder={intl.formatMessage(placeholder ?? messages.searchBy)}
            />
          </InputBox>
          {clearSearch && (
            <ClearButton
              onPress={() => {
                onChangeText('')
                input.current.focus()
              }}
            >
              <Icon name="close" scale={0.7} />
            </ClearButton>
          )}
        </Container>

        <FullWidth>{children}</FullWidth>
      </FullWidth>
    )
  },
)
